import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import PayrollTab from "./tabs/PayrollTab";

const BranchPayrollsPage = () => {
  const { branchId } = useParams();
  const navigate = useNavigate();

  return (
    <section className="admin-page">
      <header className="detail-header">
        <button className="back-btn" type="button" onClick={() => navigate('/admin/branches')}>
          ←
        </button>
        <h2 className="section-title">급여대장</h2>
      </header>

      {branchId && <PayrollTab branchId={Number(branchId)} />}
    </section>
  );
};

export default BranchPayrollsPage;
